'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductParameters({ product }: { product: ProductDetailData }) {
  const selectedVariant = useVariantsStore(state => state.selectedVariant);
  return (
    <div className="w-full">
      <div className="flex w-full flex-col items-start justify-start gap-6 md:max-w-[580px]">
        <h2 data-ea-visual-tag="h3" className="text-xl font-normal text-foreground sm:text-2xl">Parametre</h2>
        <div className="flex w-full flex-col items-start justify-start gap-0">
          {selectedVariant?.values?.length
            ? [...selectedVariant.values]
                .sort((a, b) => a.attribute_position - b.attribute_position)
                .map((value, i) => (
                  <div
                    key={value.name}
                    className={cn(
                      'flex w-full items-start justify-between gap-0 p-2',
                      i % 2 === 0 ? 'bg-[#F5F5F5]' : 'bg-white',
                    )}
                  >
                    <span className="min-w-32 max-w-32 text-sm font-normal text-foreground sm:min-w-52 lg:min-w-[200px] xl:min-w-[300px]">
                      {value.attribute_name}
                    </span>
                    <p
                      className={cn(
                        'text-right text-sm',
                        value.name === 'Veľkosť' || value.name === 'Dĺžka kábla'
                          ? 'font-medium text-foreground'
                          : 'font-normal text-primary underline',
                      )}
                    >
                      {value.name}
                    </p>
                  </div>
                ))
            : product.attributes?.map((attribute, i) => (
                <div
                  key={attribute.name}
                  className={cn(
                    'flex w-full items-start justify-between gap-0 p-2',
                    i % 2 === 0 ? 'bg-[#F5F5F5]' : 'bg-white',
                  )}
                >
                  <span className="min-w-32 max-w-32 text-sm font-normal text-foreground sm:min-w-52 lg:min-w-[200px] xl:min-w-[300px]">
                    {attribute.name}
                  </span>
                  <p
                    className={cn(
                      'text-right text-sm',
                      attribute.name === 'Veľkosť' || attribute.name === 'Dĺžka kábla'
                        ? 'font-medium text-foreground'
                        : 'font-normal text-primary underline',
                    )}
                  >
                    {attribute.values?.map((value, index) => (
                      <span key={value.name}>
                        {value.name}
                        {index < (attribute.values?.length ?? 0) - 1 ? ', ' : ''}
                      </span>
                    ))}
                  </p>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
}
